'use strict';
var isObject = require('../internals/is-object');

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (argument === undefined || isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object or undefined');
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/an-object-or-undefined.js
// module id = 307
// module chunks = 113